import React from "react"
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import { Redirect, withRouter } from "react-router-dom"
import { Form, Icon, Input, Button, Tooltip, message } from 'antd'
import { Auth } from "aws-amplify"

import LoginBase from './LoginBase'

const queryString = require('query-string');

class ForgotPasswordForm extends React.Component{

    async onSubmit(e) {

        e.preventDefault()
        this.props.form.validateFieldsAndScroll({first: true}, (err, values) => {
            if (!err) {
                Auth.forgotPassword(
                    values.email.toLowerCase().replace(/\s+/g, '')
                )
                .then(data => {
                    message.success("Codigo de verificación enviado al mail")
                    this.props.history.push('/forgot-password-confirm?' + queryString.stringify({email:values.email.toLowerCase().replace(/\s+/g, '')}))
                })
                .catch(error => {
                    if (error.code ==='InvalidParameterException'){
                        message.error('Tu cuenta aun no fue activada, ingrese codigo de verificación enviado por mail',5,onclose=this.props.history.push('/confirm-email/'+ queryString.stringify({email:values.email.toLowerCase().replace(/\s+/g, '')})))
                    } else if(error.code ==='LimitExceededException'){
                        message.error('Limite de solicitudes superado. Por favor, reintenta de nuevo más tade',5)
                    } else{
                        message.error('Ocurrio un error recuperando tu contraseña. Por favor contacta a los administradores - codigo: '+error.code,5)
                    }
                })
            }
        })
    }

    render() {

        const { getFieldDecorator } = this.props.form;

        const parsed = queryString.parse(this.props.location.search)
        let email = "email" in parsed ? parsed.email : ""

        if (this.props.login.fechingStatus === true){
            return null;
        }
        else if (this.props.login.calling === false && this.props.login.auth === true ) {
            return <Redirect to="/" />;
        }
        else {
            return (
                <LoginBase title="Reestablecer contraseña">
                    <Form
                        onSubmit={(e)=>this.onSubmit(e)}
                        hideRequiredMark={true}
                        style={{margin:"10px"}}
                    >
                        <Form.Item>
                        {
                            getFieldDecorator('email', {
                                rules: [
                                    {
                                        type: 'email',
                                        message: 'Email válido requerido!',
                                    },
                                    {
                                        required: true,
                                        message: 'Email requerido',
                                    },
                                ],
                                initialValue: email
                            })(<Input
                                    prefix={<Icon type="mail" />}
                                    placeholder="E-mail"
                                    suffix={
                                        <Tooltip title="Ingrese su email">
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    }
                                    autoComplete="email"
                                    //autoFocus={email===""}
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                            <Button
                                onClick={(e)=>this.onSubmit(e)}
                                type="primary"
                                htmlType="submit"
                                loading={this.props.login.calling}
                                //autoFocus={email!==""}
                            >
                                Enviar código
                            </Button>
                        </Form.Item>
                    </Form>
                </LoginBase>
            )
        }
    }
}

const ForgotPassword = Form.create({ name: 'forgot-password' })(ForgotPasswordForm);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForgotPassword));
